import { Controller } from 'react-hook-form';
import { NavLink } from 'react-router-dom';
import {
  InputText,
  SidePanelRow,
  IconChangeLoClock,
  PermissionEnum,
} from '@ui/src';
import { useAppSelector } from '@store';

import { ChartPanelAccountProps } from './types';

import cn from './styles.module.css';

const ChartPanelAccount = ({
  category,
  control,
  group,
  errors,
  accountNumber,
  isEditable,
  primaryId,
}: ChartPanelAccountProps): React.JSX.Element => {
  const { activePermissions } = useAppSelector((state) => state.root);

  return (
    <>
      {primaryId &&
        activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST) && (
          <div className={cn.accountChangeLog}>
            <NavLink
              to={`/administration/change-logs?entityType=ACCOUNT_PRIMARY&entityId=${primaryId}`}
              target="_blank"
              className={cn.changeLogLink}
            >
              <IconChangeLoClock />
              Change Log
            </NavLink>
          </div>
        )}
      <SidePanelRow caption="Parent category">{`${category?.number}. ${category?.name}`}</SidePanelRow>
      <SidePanelRow caption="Parent group">
        {`${group?.number}. ${group?.description}`}
      </SidePanelRow>

      <SidePanelRow caption="Account name">
        <Controller
          control={control}
          defaultValue=""
          name="description"
          render={({ field: { onChange, value } }) => (
            <InputText
              placeholder="Enter name..."
              name="description"
              value={value}
              onChange={(e) => {
                onChange(e.target.value);
              }}
              error={errors.description?.message}
              disabled={!isEditable}
            />
          )}
        />
      </SidePanelRow>
      <SidePanelRow caption="Account type">
        <div className={cn.categoryType}>{`${category?.type?.charAt(
          0,
        )}${category?.type?.slice(1).toLowerCase()}`}</div>
      </SidePanelRow>
      <div className={cn.resultWrapper}>
        <SidePanelRow
          caption={
            primaryId ? 'Current primary account' : 'New primary account'
          }
          resultBlock
        >
          <h3>{`${category?.number}.${group?.number}.${accountNumber}`}</h3>
        </SidePanelRow>
      </div>
    </>
  );
};

export default ChartPanelAccount;
